import {useQuery} from "react-query";
import ngage from "../../services/ngage";
import {CollectionFilters} from "../../services/ngage/collections";

export default function useGetCollections(
  criteria: CollectionFilters = {},
  keepPreviousData?: boolean,
  enabled?: boolean
) {
  return useQuery(
    ['collections.all', criteria],
    () => ngage.collections.all(criteria),
    {enabled, keepPreviousData}
  );
}